import React from 'react';

const I18nContext = React.createContext({});

export default I18nContext;
